<template>
      <v-navigation-drawer v-model="isShow" location="right" temporary>

        <div class="user-list">
          <template v-for="(users, role) in groupedUsers" :key="role">
            <!-- Rol -->
            <div class="role-header">{{ role.toUpperCase() }}</div>

            <div class="user-item" v-for="user in users" :key="user.email">
              <!-- Avatar -->
              <img :src="user.avatar || defaultAvatar" class="user-avatar" />

              <!-- Nombre -->
              <div class="user-info">
                <div class="user-name">{{ user.name }}</div>
              </div>
            </div>
          </template>

          <div class="role-header">DESCONECTADOS</div>

          <!-- Usuarios desconectados -->
          <div class="user-item" v-for="email in disconnectedUsers" :key="email">
            <img :src="defaultAvatar" class="user-avatar" />
            <div class="user-info">
              <div class="user-name">{{ email }}</div>
            </div>
          </div>
        </div>
      </v-navigation-drawer>
      <v-btn class="toggle-button" v-if="frontStyle == 'discord'" @click="toggleRightBar" color="primary" dark fab>
        <v-span class="mdi mdi-account-group"></v-span>
      </v-btn>
</template>

<script>
export default {
  name: "RightBar",
  props: {
    frontStyle: {
      type: String,
      default: "discord", // Puede ser 'classic' o 'discord'
    },
  },
  watch: {
    '$store.state.showMembers': function(newValue) {
      this.isShow = newValue;
    },
    isShow: function(newValue) {
      this.$store.commit('set', { att: 'showMembers', value: newValue });
    },
  },
  data() {
    return {
      isShow: false,
      defaultAvatar: "https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small_2x/default-avatar-icon-of-social-media-user-vector.jpg",
      users: [],
    };
  },
  computed: {
    groupedUsers() {
      return this.users.reduce((groups, user) => {
        const role = user.role || "Sin rol";
        if (!groups[role]) groups[role] = [];
        groups[role].push(user);
        return groups;
      }, {});
    },
    disconnectedUsers() {
      const connectedEmails = this.users.map(user => user.email);
      return this.$store.state.project?.userMembers.filter(email => !connectedEmails.includes(email));
    }
  },
  methods: {
    toggleRightBar() {
      this.isShow = !this.isShow;
    },
    conectarSocket() {
      const user = JSON.parse(localStorage.getItem("user"));
      const room = this.$route.params.projectId;

      if (!user || !room) {
        console.warn("[RightBar] No se pudo conectar al socket: Datos incompletos.");
        return;
      }

      // Esperar a que el socket esté conectado antes de emitir eventos
      if (!this.$socket.connected) {
        this.$socket.once("connect", () => {
          console.log(`[Socket] Conectado. Ahora uniendo a la sala ${room}`);
          this.$socket.emit("event_join", { room, user });
          this.$socket.emit("event_get_connected_users", { room });
        });
      } else {
        console.log("[Socket] Ya conectado. Uniendo a la sala...");
        this.$socket.emit("event_join", { room, user });
        this.$socket.emit("event_get_connected_users", { room });
      }

      // Escuchar la lista de usuarios conectados
      this.$socket.on("connected_users_list", (users) => {
        // console.log("[Socket] Usuarios conectados:", users);
        this.users = users;
      });

      // Escuchar la entrada de nuevos usuarios
      this.$socket.on("new_user", (user) => {
        if (!this.users.some((u) => u.email === user.email)) {
          this.users.push(user);
        }
      });

      // Escuchar la salida de usuarios
      this.$socket.on("left_user", (user) => {
        this.users = this.users.filter((u) => u.email !== user.email);
      });
    },
    desconectarSocket() {
      this.$socket.off("connected_users_list");
      this.$socket.off("new_user");
      this.$socket.off("left_user");
    },
  },
  created() {
    this.conectarSocket();
  },
  beforeUnmount() {
    this.desconectarSocket();
  },
};
</script>

<style scoped>
.toggle-button {
  /* Posición en la pantalla */
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: #007bff;
  color: white;
  padding: 10px;
  border-radius: 5%;
  cursor: pointer;
}

.user-list {
  margin-top: 40px;
}

.role-header {
  font-weight: bold;
  margin-top: 20px;
  user-select: none;
}

.user-item {
  display: flex;
  align-items: center;
  margin-top: 10px;
  user-select: none;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.user-info {
  margin-left: 10px;
}

.user-name {
  font-weight: bold;
}

@media (max-width: 768px) {
  .right-bar {
    width: 100%;
  }
}
</style>
